import React, { useState } from 'react';
import Text from '@amzn/meridian/text';
import Column from '@amzn/meridian/column';
import { FormattedMessage } from 'react-intl';
import {
  Contact,
  ConnectPhoneRecord,
} from '../../../api/ContactListening/schema';
import SingleRecording from './SingleRecording';
import Pagination from '@amzn/meridian/pagination';
import { CLClickstream } from '../utils/ContactListeningHelpers';
import CoachingEmptyState from '../../../Assets/coachingEmptyState.png';

export interface RecordingMediumProps {
  contact: Contact | undefined;
  contactListeningParams: any;
  isEscalation: boolean;
  CLClickstream: CLClickstream;
}

export const RecordingMedium: React.FC<RecordingMediumProps> = ({
  contact,
  contactListeningParams,
  isEscalation,
  CLClickstream,
}) => {
  const [currentRecordingIndex, setCurrentRecordingIndex] = useState(1);
  if (!contact?.medium?.connectPhoneRecordList?.length) {
    return (
      <Column alignmentHorizontal='center' alignmentVertical='center'>
        <div>
          <img src={CoachingEmptyState} alt='no contacts' />
        </div>
        <Text>
          <FormattedMessage
            id='cs_perfportal_contact_listening_no_call_recording'
            defaultMessage='There is no call recording to display here at the moment.'
          />
        </Text>
      </Column>
    );
  }
  const allRecordings: ConnectPhoneRecord[] =
    contact.medium.connectPhoneRecordList;

  if (allRecordings.length === 1) {
    return (
      <SingleRecording
        recording={allRecordings[0]}
        contactListeningParams={contactListeningParams}
        isEscalation={isEscalation}
        agentLogin={contact?.owner?.agentLogin}
        CLClickstream={CLClickstream}
      />
    );
  } else {
    return (
      <>
        <SingleRecording
          recording={allRecordings[currentRecordingIndex - 1]}
          contactListeningParams={contactListeningParams}
          isEscalation={isEscalation}
          agentLogin={contact.owner.agentLogin}
          CLClickstream={CLClickstream}
        />
        <Column heights='fill' alignmentHorizontal='center'>
          <Pagination
            numberOfPages={allRecordings.length}
            onChange={setCurrentRecordingIndex}
            currentPage={currentRecordingIndex}
          />
        </Column>
      </>
    );
  }
};
export default RecordingMedium;
